var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFrontBgNamePlate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 314,
    viewBox: "0 0 301 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 73.2172L300.5 0.882812V281.106H0.5L0.5 73.2172Z",
    fill: "#EAEEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 96.1641L300.5 1.35156V313.027H0.5L0.5 96.1641Z",
    fill: "#607EFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFrontBgNamePlate);
export default __webpack_public_path__ + "static/media/icon_front_bg_name_plate.f25dfa5ee1ab0970136d682d4f519391.svg";
export { ForwardRef as ReactComponent };